import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "menu-item me-lg-1"
}
const _hoisted_2 = { class: "menu-title" }
const _hoisted_3 = {
  key: 1,
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  class: "menu-item menu-lg-down-accordion me-lg-1"
}
const _hoisted_4 = { class: "menu-title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow d-lg-none" }, null, -1)
const _hoisted_6 = { class: "menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px" }
const _hoisted_7 = {
  key: 0,
  "data-kt-menu-trigger": "{default:'click', lg: 'hover'}",
  "data-kt-menu-placement": "right-start",
  class: "menu-item menu-lg-down-accordion"
}
const _hoisted_8 = { class: "menu-icon" }
const _hoisted_9 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_10 = { class: "menu-title" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_12 = { class: "menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px" }
const _hoisted_13 = {
  key: 0,
  "data-kt-menu-trigger": "{default:'click', lg: 'hover'}",
  "data-kt-menu-placement": "right-start",
  class: "menu-item menu-lg-down-accordion"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_15 = { class: "menu-title" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_17 = { class: "menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_19 = { class: "menu-title" }
const _hoisted_20 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_22 = { class: "menu-title" }
const _hoisted_23 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_24 = { class: "menu-icon" }
const _hoisted_25 = { class: "svg-icon svg-icon-2" }
const _hoisted_26 = { class: "menu-title" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", {
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  class: "menu-item menu-lg-down-accordion me-lg-1"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SidebarMenuConfig, (item, i) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
        (!item.heading)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.pages, (menuItem, j) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                (menuItem.heading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _createVNode(_component_router_link, {
                        class: "menu-link",
                        to: menuItem.route,
                        "active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_2, _toDisplayString(menuItem.heading.value), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          : _createCommentVNode("", true),
        (item.heading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("span", {
                class: _normalizeClass(["menu-link py-3", { active: _ctx.hasActiveChildren(item.route) }])
              }, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(item.heading.value), 1),
                _hoisted_5
              ], 2),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pages, (menuItem, j) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                    (menuItem.sectionTitle)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["menu-link py-3", { active: _ctx.hasActiveChildren(menuItem.route) }])
                          }, [
                            _createElementVNode("span", _hoisted_8, [
                              (_ctx.headerMenuIcons === 'font')
                                ? (_openBlock(), _createElementBlock("i", {
                                    key: 0,
                                    class: _normalizeClass([menuItem.fontIcon, "bi fs-3"])
                                  }, null, 2))
                                : _createCommentVNode("", true),
                              (_ctx.headerMenuIcons === 'svg')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                    (menuItem.svgIcon)
                                      ? (_openBlock(), _createBlock(_component_inline_svg, {
                                          key: 0,
                                          src: menuItem.svgIcon
                                        }, null, 8, ["src"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("span", _hoisted_10, _toDisplayString(menuItem.sectionTitle.value), 1),
                            _hoisted_11
                          ], 2),
                          _createElementVNode("div", _hoisted_12, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.sub, (menuItem1, k) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                                (menuItem1.sectionTitle)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["menu-link py-3", { active: _ctx.hasActiveChildren(menuItem1.route) }])
                                      }, [
                                        _hoisted_14,
                                        _createElementVNode("span", _hoisted_15, _toDisplayString(menuItem1.sectionTitle.value), 1),
                                        _hoisted_16
                                      ], 2),
                                      _createElementVNode("div", _hoisted_17, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem1.sub, (menuItem2, l) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: l,
                                            class: "menu-item"
                                          }, [
                                            _createVNode(_component_router_link, {
                                              class: "menu-link py-3",
                                              "active-class": "active",
                                              to: menuItem2.route
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_18,
                                                _createElementVNode("span", _hoisted_19, _toDisplayString(menuItem2.heading.value), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["to"])
                                          ]))
                                        }), 128))
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (menuItem1.heading)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                      _createVNode(_component_router_link, {
                                        class: "menu-link",
                                        "active-class": "active",
                                        to: menuItem1.route
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_21,
                                          _createElementVNode("span", _hoisted_22, _toDisplayString(menuItem1.heading.value), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (menuItem.heading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createVNode(_component_router_link, {
                            class: "menu-link",
                            "active-class": "active",
                            to: menuItem.route
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_24, [
                                _createElementVNode("span", _hoisted_25, [
                                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/layouts/lay009.svg" })
                                ])
                              ]),
                              _createElementVNode("span", _hoisted_26, _toDisplayString(menuItem.heading.value), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128)),
    _hoisted_27
  ], 64))
}